import { Routes, Route } from "react-router-dom"

// Main page
import SiftListOpportunities from "./pages/siftListOpportunities";
// Opportunity-focused pages
import SiftViewOpportunity from "./pages/viewOpportunity/siftViewOpportunity";
import SiftProcessingUpload from "./pages/opportunities/siftProcessingUpload";
import SiftNewOpportunity from "./pages/opportunities/siftNewOpportunity";
import SiftCreateOpportunity from "./pages/opportunities/siftCreateOpportunity";
// Opp-type-focused pages
import SiftOppTypesList from "./pages/oppTypes/siftOppTypesList";
import SiftOppTypeEdit from "./pages/oppTypes/siftOppTypeEdit";

const SiftApp = () => {

    return (
        <Routes>
            <Route index element={<SiftListOpportunities />} />
            <Route path="processing" element={<SiftProcessingUpload />} />
            <Route path="opportunities">
                <Route path="new" element={<SiftNewOpportunity />} />
                <Route path=":OppId?/*" element={<SiftViewOpportunity />} />
            </Route>
            <Route path="types">
                {/*<Route index element={<SiftOppTypesList />} />*/}
                {/*<Route exact path="new" element={<SiftOppTypeEdit />} />*/}
                <Route path=":OppTypeId?/*">
                    {/*<Route index element={<SiftOppTypeEdit isEditing={true} />} />*/}
                    <Route path="new" element={<SiftCreateOpportunity />} />
                </Route>
            </Route>
        </Routes>
    )
}

export default SiftApp;